<template>
  <div>
    <v-app-bar app fixed clipped-left dense :elevation="0">
      <v-app-bar-nav-icon width="40" height="40" style="margin-left: -6px;" @click.stop="drawer = !drawer"> </v-app-bar-nav-icon>
      <v-toolbar-title class="pl-0">
        <img
          :src="require('@/assets/rpd2_logo.png')"
          height="25"
          class="mt-2"
        />
      </v-toolbar-title>
      <v-toolbar-items>
        <v-btn text @click="createCompany">
          <v-icon left>mdi-office-building</v-icon>Create Company
        </v-btn>
        <v-btn text @click="createUser">
          <v-icon left>mdi-account-group</v-icon>Create Contact
        </v-btn>
        <!-- <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <v-icon left>mdi-home</v-icon>Create Property
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="createProperty">
              <v-list-item-title>Standalone Property</v-list-item-title>
            </v-list-item>
            <v-list-item @click="createSchemeProperty">
              <v-list-item-title>Scheme Property</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu> -->
      </v-toolbar-items>

      <div class="flex-grow-1"></div>
      <v-toolbar-items>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text v-on="on">
              <v-icon left>mdi-handshake</v-icon>
              New Deal
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="salesDeal">
              <v-list-item-title>Sale</v-list-item-title>
            </v-list-item>
            <v-list-item @click="lettingDeal">
              <v-list-item-title>New Letting</v-list-item-title>
            </v-list-item>
            <v-list-item @click="subLettingDeal">
              <v-list-item-title>Sub-letting/Assignment</v-list-item-title>
            </v-list-item>
            <v-list-item @click="rentReviewDeal">
              <v-list-item-title>Rent Review</v-list-item-title>
            </v-list-item>
            <v-list-item @click="leaseRenewalDeal">
              <v-list-item-title>Lease Renewal/Re-gear</v-list-item-title>
            </v-list-item>
            <v-tooltip bottom v-if="isAdmin()">
              <template v-slot:activator="{ on }">
                <v-list-item @click="tenantChangeDeal" v-on="on">
                  <v-list-item-title>Tracked Retailer</v-list-item-title>
                </v-list-item>
              </template>
              <span>Use if you know that the tenant has changed, but are not sure why.</span>
            </v-tooltip>
          </v-list>
        </v-menu>
      </v-toolbar-items>
      <v-toolbar-items>
        <v-btn text @click="addEnquiries">
          <v-icon left>mdi-email-plus</v-icon>
          Enquiries
        </v-btn>
      </v-toolbar-items>
      <!-- <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="nav-icon-btn mr-2" icon v-on="on">
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item :to="'/'">
            <v-list-item-title>Documentation</v-list-item-title>
          </v-list-item> -->
          <!--<v-list-item @click="toggleChat()">-->
          <!--<v-list-item-title>Live help chat</v-list-item-title>-->
          <!--</v-list-item>-->
        <!-- </v-list>
      </v-menu> -->
      <!--<v-btn icon :href="'https://rp-database.com/documentation'" target="_blank">-->
      <!--<v-icon>mdi-help-circle-outline</v-icon>-->
      <!--</v-btn>-->
      <!-- <v-btn
        class="nav-icon-btn mr-2"
        icon
        @click="$root.$emit('lights-switch')"
      >
        <v-icon>mdi-lightbulb-on-outline</v-icon>
      </v-btn> -->
      <v-btn class="nav-icon-btn mx-2" icon :to="'/notifications'">
        <v-icon> mdi-bell </v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-avatar
            :size="35"
            color="primary"
            v-on="on"
            style="cursor: pointer"
          >
            <span class="white--text text-h6">{{ userFirstChar }}</span>
          </v-avatar>
        </template>
        <!--<v-avatar :size="40" color="primary" slot="activator">-->
        <!--<span class="white&#45;&#45;text title">{{userFirstChar}}</span>-->
        <!--</v-avatar>-->
        <v-list>
          <v-list-item :to="'/profile'">
            <v-list-item-action>
              <v-icon>mdi-account-badge</v-icon>
            </v-list-item-action>
            <v-list-item-title>Profile</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item @click="logout()">
            <v-list-item-action>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-action>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-navigation-drawer
        v-model="drawer"
        disable-resize-watcher
        disable-route-watcher
        :mini-variant="drawer"
        expand-on-hover
        clipped
        fixed
        class="mt-12"
      >
        <v-list dense>
          <v-list-item :to="'/'">
            <v-list-item-action>
              <v-icon>mdi-account-star</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>My Properties</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/map'">
            <v-list-item-action>
              <v-icon>mdi-google-maps</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Map</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/schemes'">
            <v-list-item-action>
              <v-icon>mdi-home-group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Schemes</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/properties'">
            <v-list-item-action>
              <v-icon>mdi-home</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Properties</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-2"></v-divider>
          <v-list-item :to="'/companies'">
            <v-list-item-action>
              <v-icon>mdi-office-building</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Companies</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="'/users'">
            <v-list-item-action>
              <v-icon>mdi-account-group</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Contacts</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/pipelines'">
            <v-list-item-action>
              <v-icon>mdi-chart-line</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Pipelines</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/enquiries'">
            <v-list-item-action>
              <v-icon>mdi-email</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Enquiries</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/deals'">
            <v-list-item-action>
              <v-icon>mdi-handshake</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Deals</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/core'" v-if="$auth.check({ type: 'admin' })">
            <v-list-item-action>
              <v-icon>mdi-database</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Tracked Retailers (Admin)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/core-data'">
            <v-list-item-action>
              <v-icon>mdi-database</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Tracked Retailers</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item :to="'/reports/gap-analysis'">
            <v-list-item-action>
              <v-icon>mdi-chart-gantt</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Gap Analysis (Beta)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class="my-2"></v-divider>
        <v-list-item :href="'https://rp-database.com/docs/getting-started'" target="_blank">
          <v-list-item-action>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Documentation</v-list-item-title>
          </v-list-item-content>
        </v-list-item> 
        <!-- support tickets -->
        <v-list-item :href="'https://support.rp-database.com'" target="_blank">
          <v-list-item-action>
            <v-icon>mdi-face-agent</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Support</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        </v-list>
        <!-- <v-btn icon :to="'/help'" style="position: absolute; bottom: 56px; margin:auto; margin: 0 10px;">
          <v-icon>mdi-help-circle-outline</v-icon>
        </v-btn> -->
      </v-navigation-drawer>
      <div :style="drawer ? 'margin-left: 55px' : ''">
        <router-view></router-view>
      </div>
    </v-main>
    <!--<v-footer app fixed class="font-weight-light caption">-->
    <!--<v-col cols="3">-->
    <!--<span>&copy; {{ new Date().getFullYear() }}</span>-->
    <!--</v-col>-->
    <!--<v-col cols="8" align="right">-->
    <!--<span>For help or feature requests, please email: <a href="mailto:helpme@rpdb.app">helpme@rpdb.app</a>.</span>-->
    <!--</v-col>-->
    <!--</v-footer>-->
    <create-company-dialog ref="createCompanyDialog"></create-company-dialog>
    <create-user-dialog ref="createUserDialog"></create-user-dialog>
    <add-property-dialog ref="addPropertyDialog"></add-property-dialog>
    <add-scheme-property-dialog ref="addSchemePropertyDialog"></add-scheme-property-dialog>
    <enquiries ref="addEnquiries"></enquiries>
    <sales-deal ref="salesDeal"></sales-deal>
    <letting-deal ref="lettingDeal"></letting-deal>
    <sub-letting-deal ref="subLettingDeal"></sub-letting-deal>
    <rent-review-deal ref="rentReviewDeal"></rent-review-deal>
    <tenant-change-deal ref="tenantChangeDeal"></tenant-change-deal>
    <lease-renewal-deal ref="leaseRenewalDeal"></lease-renewal-deal>
    <video-dialog ref="videoDialog"></video-dialog>
    <whats-new ref="whatsNew"></whats-new>
  </div>
</template>
<script data-jsd-embedded data-key="434a30e4-5a5f-4dfb-a7f4-76a8237f8623" data-base-url="https://jsd-widget.atlassian.com" src="https://jsd-widget.atlassian.com/assets/embed.js"></script>
<script>
import CreateCompanyDialog from "@/components/companies/createCompanyDialog";
import CreateUserDialog from "@/components/users/createUserDialog";
import AddPropertyDialog from '@/components/properties/addPropertyDialog'
import AddSchemePropertyDialog from '@/components/properties/addSchemePropertyDialog'
import Enquiries from "@/components/enquiries/addEnquiriesDialog";
import SalesDeal from '@/components/deals/saleDealWizard.vue'
import LettingDeal from '@/components/deals/newLettingDealWizard.vue'
import SubLettingDeal from '@/components/deals/subLettingDealWizard.vue'
import RentReviewDeal from '@/components/deals/rentReviewDealWizard.vue'
import LeaseRenewalDeal from '@/components/deals/leaseRenewalDealWizard.vue'
import TenantChangeDeal from '@/components/deals/tenantChangeDealWizard.vue'
import videoDialog from "@/components/common/videoDialog.vue";
import whatsNew from '@/components/common/whatsNew.vue'

export default {
  name: "Map",
  components: {
    CreateCompanyDialog,
    CreateUserDialog,
    AddPropertyDialog,
    AddSchemePropertyDialog,
    Enquiries,
    SalesDeal,
    LettingDeal,
    SubLettingDeal,
    RentReviewDeal,
    LeaseRenewalDeal,
    TenantChangeDeal,
    videoDialog,
    whatsNew
  },
  data: () => ({
    drawer: null,
    mini: false,
    notificationMenu: false,

    videos: [
      {
        video_id: 'f9b504a827c64683826dd89484bc8894',
        video_name: 'Video 1',
        route: '/help',
      },
      {
        video_id: 'f9b504a8276dd89484bc8894',
        video_name: 'Video 2',
        route: '/help',
      },
      {
        video_id: 'f9b504a8276dd89484bc8894',
        video_name: 'Video 3',
        route: '/help',
      },
      {
        video_id: 'f9b504a8276dd83455349484bc8894',
        video_name: 'Video 4',
        route: '/companies',
      },
      {
        video_id: 'f9b504a8276324243dd83455349484bc8894',
        video_name: 'Video 5',
        route: '/companies',
      },
    ]
  }),
  watch: {
    currentRoute() {
      let vids = this.videos.filter(video => video.route === this.currentRoute)
      if(!vids) return
      vids = vids.filter(video => !this.$auth.user().settings.hidden_videos.includes(video.video_id))
      
      let hiddenvids = JSON.parse(sessionStorage.getItem('hiddenVideos'))

      // filter again by all ids in hiddenVideos
      if(hiddenvids) {
        vids = vids.filter(video => !hiddenvids.includes(video.video_id))
      }

      if(vids.length > 0) {
        // this.$refs.videoDialog.openDialog(vids)
      }
    }
  },
  mounted() {
    //get notifications
    // this.getNotificationsCount()
    this.$store.dispatch('getNotificationsCount')
    // this.getNotifications()
  },
  computed: {
    userFirstChar: function () {
      if (!this.$auth.user().name) return;
      return this.$auth
        .user()
        .name.replace(/[^a-zA-Z- ]/g, "")
        .match(/\b\w/g)
        .join("")
        .substring(0, 2)
        .toUpperCase();
    },
    notificationsCount: {
      get() {
        return this.$store.state.notifications.unread;
      },
    },
    currentRoute() {
      return this.$route.path;
    }
  },
  methods: {
    async getNotifications() {
      //get notifications
      this.page = 1;
      const response = await this.$http.get(`/notifications`,{
        params: {
          page: this.page,
        }
      });
      this.notifications.records = response.data.data;
      this.notifications.total = response.data.meta.pagination.total;
      this.notifications.loadMore = response.data.meta.pagination.total > response.data.meta.pagination.per_page * this.page;
    },
    async getNotificationsCount() {
      const response = await this.$http.get(`/notifications/unread-count`);
      this.notificationsCount = response.data.unread_count;
    },
    async loadMoreNotifications() {
      this.page = this.page + 1;
      const response = await this.$http.get(`/notifications`,{
        params: {
          page: this.page,
        }
      });
      this.notifications.records = this.notifications.records.concat(response.data.data);
      this.notifications.loadMore = response.data.meta.pagination.total > response.data.meta.pagination.per_page * this.page;
    },
    createCompany() {
      this.$refs.createCompanyDialog.showDialog();
    },
    createUser() {
      this.$refs.createUserDialog.showDialog();
    },
    createProperty() {
      this.$refs.addPropertyDialog.openDialog();
    },

    createSchemeProperty() {
      this.$refs.addSchemePropertyDialog.openDialog();
    },

    addEnquiries() {
      this.$refs.addEnquiries.showDialog();
    },

    salesDeal() {
      this.$refs.salesDeal.showDialog();
    },
    lettingDeal() {
      this.$refs.lettingDeal.showDialog();
    },
    subLettingDeal() {
      this.$refs.subLettingDeal.showDialog();
    },
    leaseRenewalDeal() {
      this.$refs.leaseRenewalDeal.showDialog();
    },
    rentReviewDeal() {
      this.$refs.rentReviewDeal.showDialog();
    },
    tenantChangeDeal() {
      this.$refs.tenantChangeDeal.showDialog();
    },
    //  this.$root.$emit('lights-switch')
    logout() {
      console.log("logging out");
      this.$auth.logout({
        makeRequest: true,
      });
    },
    toggleChat() {
      const x = document.getElementById("Smallchat");
      if (x.style.display === "none") {
        x.style.display = "block";
      } else {
        x.style.display = "none";
      }
    },
  },
};
</script>

<style>
html,
body {
  height: 100%;
  margin: 0;
  padding: 0;
}
</style>
